import request from "./requests";

export const TRAIT_CATEGORIES = [
  { key: "lifestyle", label: "Lifestyle" },
  { key: "interests", label: "Interests" },
  { key: "values", label: "Values" },
  { key: "personality", label: "Personality" },
  { key: "intimacy", label: "Intimacy" },
  { key: "relationships", label: "Relationships" },
  { key: "communication", label: "Communication" },
  { key: "boundaries", label: "Boundaries" },
  { key: "ambitions", label: "Ambitions" },
  { key: "identity", label: "Identity" },
];

export const getMatchmakerProfile = async () => request("matchprofile/profile");

export const startMatchmakerProfile = async () =>
  request("matchprofile/start", "post", {});

export const getTraits = async () => request("matchprofile/traits");

export const deleteTrait = async ({ id, promptType }) =>
  request("matchprofile/traits/delete", "post", { id, promptType });

export const submitTranscripts = async ({ aboutMe, lookingFor }) =>
  request("matchprofile/transcripts", "post", { aboutMe, lookingFor });

export const getMyMatches = async () => request("matchmakerengine/mine");

export const sendMatchInterest = async (matchId) =>
  request("matchmakerengine/interest", "post", { matchId });

export const passMatch = async (matchId) =>
  request("matchmakerengine/pass", "post", { matchId });

export const acknowledgeInterest = async () =>
  request("matchmakerengine/ack-interest", "post", {});

export const getProfilePhoto = async (userId) =>
  request(`profile/photo?userId=${userId}`);

export const submitMatchFeedback = async (matchId, feedback) =>
  request("matchmakerengine/feedback", "post", { matchId, feedback });
